<template>
  <v-app>
    <v-layout class="background">
      <SideBar v-if="isLoggedIn" />
      <PushSideBar v-if="isLoggedIn" />
      <router-view name="pass-through-nav-bar" />
      <v-main class="d-flex flex-column align-start justify-start w-100">
        <div class="w-100 pa-4">
          <router-view />
        </div>
        <NavFooter />
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import NavFooter from './components/navigation/NavFooter.vue'
import PushSideBar from './components/navigation/sidebar/PushSideBar.vue'
import SideBar from './components/navigation/sidebar/SideBar.vue'
import { setDocumentTitle } from './util/util'

const store = useStore()

const isLoggedIn = computed(() => store.state.global.isLoggedIn)

onMounted(() => {
  const document = window.document
  const favicon = document.getElementById('favicon')
  // TODO: MigraTE favicon.href = '/img/brelag/favicon_new.ico'

  setDocumentTitle('Brelag Styler')

  iframeBreakout()
})

function iframeBreakout() {
  if (top.location !== location) {
    top.location.href = document.location.href
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;300;400;500;600;700&display=swap');

.background {
  background-color: #e5e5e5;
}
.navbar-hidden {
  padding-top: 20px !important;
}
</style>
